import { createReducer } from '@reduxjs/toolkit';
import { CurrentReceiptData, LoyaltyPageState } from './types';
import * as actions from './actions';
import { AppState } from '../../global/types';

const initialState: LoyaltyPageState = {
  currentReceipt: {
    data: null,
    lastUpdate: null,
    loading: false,
    error: null,
  },
  chosenReceipt: {
    data: null,
  },
  appliedBonuses: {
    loading: false,
    error: null,
    result: null,
  },
  loyaltyOrder: {
    loading: false,
    error: null,
    result: null,
  },
  partnerPayments: {
    loading: false,
    data: null,
    error: null,
  },
  loyaltyOrderId: null,
  orderReceiptInfo: null,
  bonusUsed: false,
  sendToStandart: {
    data: null,
    error: null,
  },
  healthStatus: {
    data: null,
    error: null,
  },
  clientInfo: {
    result: null,
    loading: false,
    error: null,
  },
  clientOrders: {
    result: null,
    loading: false,
    error: null,
  },
  pharmacistTodayBonuses: {
    result: null,
    loading: false,
    error: null,
  },
  stadaInfo: {
    result: null,
  },
  pdfLoyaltyReport: {
    data: null,
    loading: false,
    error: null,
  },
  loyaltyProducts: {
    data: [],
    totalCount: 0,
    loading: false,
    error: null,
  },
  loyaltyPercentages: {
    data: null,
    loading: false,
    error: null,
  },
  recommendations: {
    data: [],
    loading: false,
    error: null,
    loaded: false,
  },
  creditBonuses: {
    loading: false,
    error: null,
    result: null,
  },
};

const reducer = createReducer(initialState, {
  [actions.getCurrentReceipt.REQUEST]: (state) => {
    state.currentReceipt.loading = true;
  },
  [actions.getCurrentReceipt.SUCCESS]: (state, action) => {
    state.currentReceipt.loading = false;
    state.currentReceipt.error = null;

    const chosenReceipt = action.payload.checks.find(
      (item: CurrentReceiptData) =>
        item.doc_id === state.chosenReceipt.data?.doc_id
    );

    const stopUpdate =
      !!state.loyaltyOrder.result &&
      action.payload.checks.find(
        (item: CurrentReceiptData) => item.doc_id === state.loyaltyOrder.result
      )?.items?.length > 0;

    if (!stopUpdate) {
      state.currentReceipt.lastUpdate = new Date().toLocaleString();
      state.currentReceipt.data = action.payload.checks;
      state.chosenReceipt.data = chosenReceipt ?? null;
    }
  },
  [actions.getCurrentReceipt.ERROR]: (state, action) => {
    state.currentReceipt.loading = false;
    state.currentReceipt.lastUpdate = new Date().toLocaleString();
    state.currentReceipt.data = null;
    state.currentReceipt.error = action.payload;
  },
  [actions.setChosenReceipt.REQUEST]: (state, action) => {
    state.chosenReceipt.data = action.payload;
  },
  [actions.applyBonuses.REQUEST]: (state) => {
    state.appliedBonuses.loading = true;
    state.appliedBonuses.error = null;
    state.appliedBonuses.result = null;
    state.loyaltyOrder.error = null;
    state.loyaltyOrder.result = null;
  },
  [actions.applyBonuses.SUCCESS]: (state, action) => {
    state.appliedBonuses.loading = false;
    state.appliedBonuses.result = action.payload;
  },
  [actions.applyBonuses.ERROR]: (state, action) => {
    state.appliedBonuses.loading = false;
    state.appliedBonuses.error = action.payload;
  },
  [actions.getClientInfo.REQUEST]: (state) => {
    state.clientInfo.loading = true;
  },
  [actions.getClientInfo.SUCCESS]: (state, action) => {
    state.clientInfo.loading = false;
    state.clientInfo.result = action.payload.pharmacy;
    state.stadaInfo.result = action.payload.stada ?? null;
  },
  [actions.getClientInfo.ERROR]: (state, action) => {
    state.clientInfo.loading = false;
    state.clientInfo.error = action.payload.response?.data?.error;
  },
  [actions.getPharmacistTodayBonuses.REQUEST]: (state) => {
    state.pharmacistTodayBonuses.loading = true;
    state.pharmacistTodayBonuses.error = null;
  },
  [actions.getPharmacistTodayBonuses.SUCCESS]: (state, action) => {
    state.pharmacistTodayBonuses.loading = false;
    state.pharmacistTodayBonuses.result = action.payload;
  },
  [actions.getPharmacistTodayBonuses.ERROR]: (state, action) => {
    state.pharmacistTodayBonuses.loading = false;
    state.pharmacistTodayBonuses.error = action.payload;
  },
  [actions.getClientOrders.REQUEST]: (state) => {
    state.clientOrders.loading = true;
  },
  [actions.getClientOrders.SUCCESS]: (state, action) => {
    state.clientOrders.loading = false;
    state.clientOrders.result = action.payload.pharmacy;
    state.loyaltyOrderId = action.payload.order_id;
    state.bonusUsed = action.payload.bonus_used;
    state.orderReceiptInfo = action.payload;
  },
  [actions.getClientOrders.ERROR]: (state, action) => {
    state.clientOrders.loading = false;
    state.clientOrders.error = action.payload.response?.data?.error;
  },
  [actions.submitLoyaltyOrder.REQUEST]: (state) => {
    state.loyaltyOrder.loading = true;
    state.loyaltyOrder.error = null;
    state.loyaltyOrder.result = null;
  },
  [actions.submitLoyaltyOrder.SUCCESS]: (state, action) => {
    state.loyaltyOrder.loading = false;
    state.loyaltyOrder.result = action.payload.docId;
    state.bonusUsed = action.payload.bonusUsed;

    state.loyaltyOrderId = action.payload.result?.id ?? null;
  },
  [actions.submitLoyaltyOrder.ERROR]: (state, action) => {
    state.loyaltyOrder.loading = false;
    state.loyaltyOrder.error = action.payload;
  },
  [actions.getPartnerPayments.REQUEST]: (state) => {
    state.partnerPayments.loading = true;
    state.partnerPayments.error = null;
  },
  [actions.getPartnerPayments.SUCCESS]: (state, action) => {
    state.partnerPayments.loading = false;
    state.partnerPayments.error = null;
    state.partnerPayments.data = action.payload;
  },
  [actions.getPartnerPayments.ERROR]: (state, action) => {
    state.partnerPayments.loading = false;
    state.partnerPayments.error = action.payload;
  },
  [actions.sendToStandart.REQUEST]: (state) => {
    state.sendToStandart.data = null;
    state.sendToStandart.error = null;
  },
  [actions.sendToStandart.SUCCESS]: (state, action) => {
    state.sendToStandart.data = action.payload;
    state.sendToStandart.error = null;
  },
  [actions.sendToStandart.ERROR]: (state, action) => {
    state.sendToStandart.data = null;
    state.sendToStandart.error = action.payload;
  },
  [actions.getHealthStatus.SUCCESS]: (state, action) => {
    state.healthStatus.data = action.payload;
  },
  [actions.getHealthStatus.ERROR]: (state, action) => {
    state.healthStatus.error = action.payload;
  },
  [actions.resetClientInfo.type]: (state) => {
    state.clientInfo.loading = false;
    state.clientInfo.error = null;
    state.clientInfo.result = null;
    state.stadaInfo.result = null;
    state.clientOrders.result = null;
    state.orderReceiptInfo = null;
  },
  [actions.resetCurrentReceipt.type]: (state) => {
    state.currentReceipt.loading = false;
    state.currentReceipt.error = null;
    state.currentReceipt.data = null;
    state.currentReceipt.lastUpdate = null;
    state.loyaltyOrder.result = null;
    state.bonusUsed = false;
  },
  [actions.resetApplyBonuses.type]: (state) => {
    state.appliedBonuses.loading = false;
    state.appliedBonuses.error = null;
    state.appliedBonuses.result = null;
  },
  [actions.resetSubmitOrder.type]: (state) => {
    state.loyaltyOrder.loading = false;
    state.loyaltyOrder.error = null;
    state.loyaltyOrder.result = null;
    state.loyaltyOrderId = null;
    state.orderReceiptInfo = null;
    state.bonusUsed = false;
    state.sendToStandart.error = null;
    state.sendToStandart.data = null;
    state.partnerPayments.loading = false;
    state.partnerPayments.error = null;
    state.partnerPayments.data = null;
  },
  [actions.generateLoyaltyReport.REQUEST]: (state) => {
    state.pdfLoyaltyReport.loading = true;
  },
  [actions.generateLoyaltyReport.SUCCESS]: (state, action) => {
    state.pdfLoyaltyReport.loading = false;
    state.pdfLoyaltyReport.data = action.payload;
  },
  [actions.generateLoyaltyReport.ERROR]: (state, action) => {
    state.pdfLoyaltyReport.loading = false;
    state.pdfLoyaltyReport.error = action.payload;
  },
  [actions.getLoyaltyProducts.REQUEST]: (state) => {
    state.loyaltyProducts.loading = true;
    state.loyaltyProducts.error = null;
  },
  [actions.getLoyaltyProducts.SUCCESS]: (state, action) => {
    state.loyaltyProducts.loading = false;
    state.loyaltyProducts.data = action.payload?.result ?? [];
    state.loyaltyProducts.totalCount = action.payload?.total_count ?? 0;
  },
  [actions.getLoyaltyProducts.ERROR]: (state, action) => {
    state.loyaltyProducts.loading = false;
    state.loyaltyProducts.error = action.payload;
  },
  [actions.getLoyaltyPercentages.REQUEST]: (state) => {
    state.loyaltyPercentages.loading = true;
    state.loyaltyPercentages.error = null;
  },
  [actions.getLoyaltyPercentages.SUCCESS]: (state, action) => {
    state.loyaltyPercentages.loading = false;
    state.loyaltyPercentages.data = action.payload?.result ?? null;
  },
  [actions.getLoyaltyPercentages.ERROR]: (state, action) => {
    state.loyaltyPercentages.loading = false;
    state.loyaltyPercentages.error = action.payload;
  },
  [actions.getRecommendations.REQUEST]: (state) => {
    state.recommendations.loading = true;
    state.recommendations.error = null;
  },
  [actions.getRecommendations.SUCCESS]: (state, action) => {
    state.recommendations.loading = false;
    state.recommendations.error = null;
    state.recommendations.data = action.payload?.recommendations ?? [];
    state.recommendations.loaded = true;
  },
  [actions.getRecommendations.ERROR]: (state, action) => {
    state.recommendations.loading = false;
    state.recommendations.error = action.payload;
    state.recommendations.loaded = true;
  },
  [actions.creditBonuses.REQUEST]: (state) => {
    state.creditBonuses.loading = true;
    state.creditBonuses.error = null;
    state.creditBonuses.result = null;
  },
  [actions.creditBonuses.SUCCESS]: (state, action) => {
    state.creditBonuses.loading = false;
    state.creditBonuses.result = action.payload;
  },
  [actions.creditBonuses.ERROR]: (state, action) => {
    state.creditBonuses.loading = false;
    state.creditBonuses.error = action.payload;
  },
});

const currentReceipt = (state: AppState) =>
  state.loyaltyPageReducer.currentReceipt.data;
const currentReceiptLoading = (state: AppState) =>
  state.loyaltyPageReducer.currentReceipt.loading;
const currentReceiptError = (state: AppState) =>
  state.loyaltyPageReducer.currentReceipt.error;
const chosenReceipt = (state: AppState) =>
  state.loyaltyPageReducer.chosenReceipt.data;
const orderReceiptInfo = (state: AppState) =>
  state.loyaltyPageReducer.orderReceiptInfo;
const lastUpdateTime = (state: AppState) =>
  state.loyaltyPageReducer.currentReceipt.lastUpdate;
const appliedBonuses = (state: AppState) =>
  state.loyaltyPageReducer.appliedBonuses.result;
const appliedBonusesLoading = (state: AppState) =>
  state.loyaltyPageReducer.appliedBonuses.loading;
const appliedBonusesError = (state: AppState) =>
  state.loyaltyPageReducer.appliedBonuses.error;
const clientInfo = (state: AppState) =>
  state.loyaltyPageReducer.clientInfo.result;
const clientInfoLoading = (state: AppState) =>
  state.loyaltyPageReducer.clientInfo.loading;
const clientInfoError = (state: AppState) =>
  state.loyaltyPageReducer.clientInfo.error;
const pharmacistTodayBonuses = (state: AppState) =>
  state.loyaltyPageReducer.pharmacistTodayBonuses.result;
const pharmacistTodayBonusesLoading = (state: AppState) =>
  state.loyaltyPageReducer.pharmacistTodayBonuses.loading;
const pharmacistTodayBonusesError = (state: AppState) =>
  state.loyaltyPageReducer.pharmacistTodayBonuses.error;
const stadaInfo = (state: AppState) =>
  state.loyaltyPageReducer.stadaInfo.result;
const resetClientInfo = (state: AppState) =>
  state.loyaltyPageReducer.clientInfo.result;
const submitOrderError = (state: AppState) =>
  state.loyaltyPageReducer.loyaltyOrder.error;
const submitOrderResult = (state: AppState) =>
  state.loyaltyPageReducer.loyaltyOrder.result;
const partnerPayments = (state: AppState) =>
  state.loyaltyPageReducer.partnerPayments.data;
const loyaltyOrderId = (state: AppState) =>
  state.loyaltyPageReducer.loyaltyOrderId;
const bonusUsed = (state: AppState) => state.loyaltyPageReducer.bonusUsed;
const submitOrderLoading = (state: AppState) =>
  state.loyaltyPageReducer.loyaltyOrder.loading;
const sendToStandartSuccess = (state: AppState) =>
  state.loyaltyPageReducer.sendToStandart.data;
const sendToStandartError = (state: AppState) =>
  state.loyaltyPageReducer.sendToStandart.error;
const healthStatusSuccess = (state: AppState) =>
  state.loyaltyPageReducer.healthStatus.data;
const healthStatusError = (state: AppState) =>
  state.loyaltyPageReducer.healthStatus.error;
const resetSubmitOrder = (state: AppState) =>
  state.loyaltyPageReducer.loyaltyOrder.result;
const resetApplyBonuses = (state: AppState) =>
  state.loyaltyPageReducer.appliedBonuses.result;
const loyaltyPdf = (state: AppState) =>
  state.loyaltyPageReducer.pdfLoyaltyReport.data;
const loyaltyPdfLoading = (state: AppState) =>
  state.loyaltyPageReducer.pdfLoyaltyReport.loading;
const loyaltyProducts = (state: AppState) =>
  state.loyaltyPageReducer.loyaltyProducts.data;
const loyaltyProductsLoading = (state: AppState) =>
  state.loyaltyPageReducer.loyaltyProducts.loading;
const loyaltyPercentages = (state: AppState) =>
  state.loyaltyPageReducer.loyaltyPercentages.data;
const loyaltyPercentagesLoading = (state: AppState) =>
  state.loyaltyPageReducer.loyaltyPercentages.loading;
const recommendations = (state: AppState) =>
  state.loyaltyPageReducer.recommendations.data;
const recommendationsLoading = (state: AppState) =>
  state.loyaltyPageReducer.recommendations.loading;
const recommendationsError = (state: AppState) =>
  state.loyaltyPageReducer.recommendations.error;
const recommendationsLoaded = (state: AppState) =>
  state.loyaltyPageReducer.recommendations.loaded;
const creditBonusesLoading = (state: AppState) =>
  state.loyaltyPageReducer.creditBonuses.loading;
const creditBonusesError = (state: AppState) =>
  state.loyaltyPageReducer.creditBonuses.error;
const creditBonusesResult = (state: AppState) =>
  state.loyaltyPageReducer.creditBonuses.result;

const selectors = {
  currentReceipt,
  currentReceiptLoading,
  currentReceiptError,
  chosenReceipt,
  orderReceiptInfo,
  lastUpdateTime,
  appliedBonuses,
  appliedBonusesLoading,
  appliedBonusesError,
  clientInfo,
  clientInfoLoading,
  clientInfoError,
  pharmacistTodayBonuses,
  pharmacistTodayBonusesLoading,
  pharmacistTodayBonusesError,
  stadaInfo,
  resetClientInfo,
  submitOrderError,
  submitOrderResult,
  submitOrderLoading,
  partnerPayments,
  loyaltyOrderId,
  bonusUsed,
  sendToStandartSuccess,
  sendToStandartError,
  healthStatusSuccess,
  healthStatusError,
  resetSubmitOrder,
  resetApplyBonuses,
  loyaltyPdf,
  loyaltyPdfLoading,
  loyaltyProducts,
  loyaltyProductsLoading,
  loyaltyPercentages,
  loyaltyPercentagesLoading,
  recommendations,
  recommendationsLoading,
  recommendationsError,
  recommendationsLoaded,
  creditBonusesLoading,
  creditBonusesError,
  creditBonusesResult,
};

export { selectors };
export default reducer;
